import styles from '@components/Accordion/styles.module.scss';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowLineDown from '@icons/arrow/ArrowLineDown';
import {
  ReactNode, useEffect, useRef, useState,
} from 'react';

interface Props {
    name: string;
    children?: ReactNode;
}

const ANIMATION_DURATION_MS = 300;

function PermissionItem({ name, children }:Props) {
  const [expand, setExpand] = useState(false);
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      setMaxHeight(ref.current.scrollHeight);
      const timeout = setTimeout(() => {
        setIsLoad(true);
      }, ANIMATION_DURATION_MS);
      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [ref.current, children]);
  return (
      <Column fullWidth>
          <Row fullWidth
               onClick={() => setExpand(!expand)} >
              <Leading>
                  <TypeWrapper>
                      <Text color={colors.white}>
                          선택
                      </Text>
                  </TypeWrapper>
                  <Text color={colors.gray6} fontWeight='bold' size='lg'>
                      {name}
                  </Text>
              </Leading>
              <Arrow expand={expand}>
                  <ArrowLineDown size={24}/>
              </Arrow>
          </Row>
          <Content ref={ref}
               isLoad={isLoad}
               maxHeight={expand ? maxHeight : 0} >
              <ContentWrapper>
                  <Text color={colors.gray6}>
                      {children}
                  </Text>
              </ContentWrapper>
          </Content>
      </Column>
  );
}

const Leading = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
    flex: 1;
`;

const TypeWrapper = styled.div`
    background-color: ${colors.gray4};
    border-radius: 10px;
    padding: 0 6px;
`;

const Content = styled.div<{
    isLoad: boolean,
    maxHeight: number}>`
    max-height: ${(props) => props.maxHeight}px;
    overflow: hidden;
    transition: ${(props) => (props.isLoad ? 'max-height 200ms ease-in-out' : 'none')};
`;

const ContentWrapper = styled.div`
    padding: 8px 0 12px;
`;

const Arrow = styled.div<{expand: boolean}>`
    transition: 200ms;
    transform: rotate(${(props) => (props.expand ? '180deg' : '0deg')});
`;

export default PermissionItem;
